import * as React from 'react'
import { styling } from 'common/utils'
import { DynamicCx } from 'common/types'
const s = require(`./error_${process.env.PROJECT_NAME}.scss`)

export enum MessageTypes {
  CONNECT_FAILURE = 'CONNECT_FAILURE',
  NO_CONTENTS = 'NO_CONTENTS',
  SOLDOUT = 'SOLDOUT',
  NOT_FOUND = 'NOT_FOUND',
  UNDER_CONSTRUCTION = 'UNDER_CONSTRUCTION',
  STORE_NOT_FOUND = 'STORE_NOT_FOUND',
}

export namespace MessageTypes {
  interface Message {
    main: JSX.Element
    sub: JSX.Element
    title: string
  }
  type Messages = { [key in MessageTypes]: Message }

  const messages: Messages = {
    CONNECT_FAILURE: {
      main: (
        <>
          현재 서비스에 <em>접속하기 어렵습니다.</em>
        </>
      ),
      sub: (
        <>
          죄송합니다!<br />지금은 사용자가 많아 접속이 지연되고 있습니다.<br />잠시 후 다시 이용해주세요.
        </>
      ),
      title: 'NAVER 쇼핑윈도',
    },
    NO_CONTENTS: {
      main: (
        <>
          페이지에 <em>등록된 내용이 없습니다.</em>
        </>
      ),
      sub: (
        <>
          죄송합니다.<br />이 컨텐츠는 현재 노출이 종료된 컨텐츠입니다.<br />다시 한 번 확인 부탁드립니다.
        </>
      ),
      title: 'NAVER 쇼핑윈도',
    },
    SOLDOUT: {
      main: <>해당 상품은 판매중인 상품이 아닙니다.</>,
      sub: (
        <>
          <em>
            선택하신 상품은 일시 품절이거나<br /> 노출 제한된 상품일 수 있습니다.
          </em>{' '}
          추가 문의사항은 고객센터(1588-3819)로<br />문의주시면 친절히 안내해드리겠습니다.
        </>
      ),
      title: 'NAVER 쇼핑윈도',
    },
    NOT_FOUND: {
      main: (
        <>
          페이지를 <em>찾을 수 없습니다.</em>
        </>
      ),
      sub: (
        <>
          요청하신 주소의 페이지를 찾을 수 없습니다.<br />주소가 잘못되었거나 변경 또는 삭제되었을 수 있어요.<br />다시
          한 번 확인 부탁드립니다.
        </>
      ),
      title: 'NAVER 쇼핑윈도',
    },
    UNDER_CONSTRUCTION: {
      main: (
        <>
          더 좋은 서비스를 제공해드리기 위해<br />
          <em>현재 임시점검 중입니다.</em>
        </>
      ),
      sub: (
        <>
          이용에 불편을 드려 정말 죄송합니다.<br />예정 시간 안에 더 나은 모습으로 돌아오겠습니다.
        </>
      ),
      title: 'NAVER 쇼핑윈도',
    },
    STORE_NOT_FOUND: {
      main: (
        <>
          판매자의 사정으로<br />
          <em>현재 운영되지 않습니다.</em>
        </>
      ),
      sub: (
        <>
          주문하신 이력이 있으신 경우,<br />
          <a href="https://order.pay.naver.com/home" target="_blank">
            네이버페이 > 결제내역
          </a>에서 확인하실 수 있습니다.<br />
          추가 문의사항은 고객센터(1588-3819)로<br />문의주시면 친절히 안내해드리겠습니다.
        </>
      ),
      title: 'NAVER 쇼핑윈도',
    },
  }

  export const getMessages = (status: MessageTypes): Message => messages[status]
  export const getValues = (): MessageTypes[] =>
    Object.keys(MessageTypes)
      .filter(e => messages[e] instanceof Object)
      .map(e => MessageTypes[e])
}

interface OwnProps {
  message: MessageTypes
  cx?: DynamicCx
}

const Error: React.SFC<OwnProps> = ({ message, cx }) => {
  const handleHistoryBack = () => {
    if (navigator.userAgent.match(/NAVER\(inapp; search;/g) || navigator.userAgent.match(/NAVER\(higgs; search;/g)) {
      if (1 < history.length) {
        window.history.back()
      } else {
        window.location.href = 'naverapp://closewindow'
      }
    } else {
      window.history.back()
    }
  }

  const handleMoveHome = () => {
    window.location.href = `${window.location.protocol}//${window.location.hostname}`
  }

  const messages = MessageTypes.getMessages(message)

  return (
    <div className={cx('content_error')}>
      <h2 className={cx('head')}>{messages && messages.main}</h2>
      <p className={cx('desc')}>{messages && messages.sub}</p>
      {message &&
        message === MessageTypes.UNDER_CONSTRUCTION && (
          <p className={cx('term')}>
            <span className={cx('term_title')}>점검 예정 시간 : </span>
            <span className={cx('term_time')}>
              <em>
                15년 3월 7일(토) <br />오전 00:00~07:00
              </em>{' '}
              (약 7시간)
            </span>
          </p>
        )}
      <div className={cx('btn_area')}>
        <a href="javascript:void(0)" onClick={handleHistoryBack}>
          이전 페이지
        </a>
        <a href="javascript:void(0)" onClick={handleMoveHome}>
          네이버쇼핑 홈
        </a>
      </div>
    </div>
  )
}

const styled = styling(s)(Error)
export default styled
